import { render, staticRenderFns } from "./date-field.vue?vue&type=template&id=17384aa4"
import script from "./date-field.vue?vue&type=script&lang=js"
export * from "./date-field.vue?vue&type=script&lang=js"
import style0 from "./date-field.vue?vue&type=style&index=0&id=17384aa4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports